// import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const { 
    REACT_APP_BASE_URL_GIS_SERVER } = window['runConfig'];

export const getNRWTable = (token, whereClause) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_DMA_NRW_V1/FeatureServer/Query`;

            const bodyFormData_getNRWTable = new FormData();
            bodyFormData_getNRWTable.set('f', 'json')
            // const tamp = [{"layerId" : 1, "where" : "DMAID = 'DMZ 030'", "outFields" : "*"}]
            const tamp = [{ "layerId": 2, "where": `${whereClause}`, "outFields": "*" }]
            bodyFormData_getNRWTable.append('layerDefs', JSON.stringify(tamp))

            bodyFormData_getNRWTable.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getNRWTable,
            })

        });

    return res;
}

export const postNRWTable = (token, arrayOfObjectToInput) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_DMA_NRW_V1/FeatureServer/2/addFeatures`;

            const bodyFormData_postNRWTable = new FormData();
            bodyFormData_postNRWTable.set('f', 'json')
            bodyFormData_postNRWTable.append('features', JSON.stringify(arrayOfObjectToInput));
            bodyFormData_postNRWTable.append('rollbackOnFailure', 'True');

            bodyFormData_postNRWTable.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_postNRWTable,
            })
        });

    return res;



    //example
    // const input = [
    //     {
    //       "attributes": {
    //         "dmaid": "DMZ 036",
    //         "total_connections": "1000",
    //         "total_length": "2345",
    //         "WATER_SUPPLIED": "32",
    //         "water_supplied": "15",
    //         "bill_meter_consump": "1",
    //         "bill_unmeter_consump": "1000",
    //         "unbill_auth_consump": "1000",
    //         "unauth_consump": "1000",
    //         "cus_meter_inaccura": "1000",
    //         "non_rev_water_nrw": "1000",
    //         "percent_nrw": "1000",
    //         "water_losses": "1000",
    //         "lastupdated": "2020-07-23"
    //       }
    //     }
    //   ]

    // const whereClause = "DMAID = 'DMZ 004"
}

export const postNRWTableToGIS = (token, arrayOfObjectToInput) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_DMA_NRW_V1/FeatureServer/1/updateFeatures`;

            const bodyFormData_postNRWTableToGIS = new FormData();
            bodyFormData_postNRWTableToGIS.set('f', 'json')
            bodyFormData_postNRWTableToGIS.append('features', JSON.stringify(arrayOfObjectToInput));
            bodyFormData_postNRWTableToGIS.append('rollbackOnFailure', 'True');

            bodyFormData_postNRWTableToGIS.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_postNRWTableToGIS,
            })
        });

    return res;


    // [
    //     {   
    //       "attributes" : {
    //         "OBJECTID" : 431,     
    //         "TOTAL_CONNECTIONS" : 1,
    //         "TOTAL_LENGTH" : 2,
    //         "WATER_SUPPLIED" : 3,	  
    //         "AVERAGE_PRESSURE" : 4,
    //         "BILL_METER_CONSUMP" : 5,     
    //         "NON_REV_WATER_NRW" : 7,
    //         "PERCENT_NRW" : 8,  
    //         "WATER_LOSSES" : 9,
    //         "PERCENT_WATER_LOSS" : 10,
    //         "YEAR" : 2020,
    //         "MONTH" : 7
    //       }
    //     },
    //     {   
    //       "attributes" : {
    //         "OBJECTID" : 434,     
    //         "TOTAL_CONNECTIONS" : 1,
    //         "TOTAL_LENGTH" : 2,
    //         "WATER_SUPPLIED" : 3,	  
    //         "AVERAGE_PRESSURE" : 4,
    //         "BILL_METER_CONSUMP" : 5,      	 
    //         "NON_REV_WATER_NRW" : 7,
    //         "PERCENT_NRW" : 8,	  
    //         "WATER_LOSSES" : 9,
    //         "PERCENT_WATER_LOSS" : 10,
    //         "YEAR" : 2020,
    //         "MONTH" : 7 
    //       }
    //     }
    //   ]
}
